<template>
  <div id="login-container">
    <Header :logged="false"/>
    <section class="body-container">

      <section class="login-container">

        <h1 class="login-tittle">Biomanager</h1>

        <form @submit.prevent="checkCreds">

          <div class="login-input-box">

            <div class="login-label">
              <span>*</span> CPF:
            </div>
            <input
              class="login-input"
              id="cpf"
              type="text"
              maxlength="14"
              placeholder="Digite seu cpf"
              v-model="maskCpf"
              v-on:change="checkBiometric"
            />
          </div>

          <div class="login-input-box">
            <div class="login-label">
              <span>*</span> Selecione a biometria:
            </div>
            <select id="biometrics" class="login-input" v-model="biometria">
              <option value="" selected disabled hidden>Escolha aqui</option>
              <option v-for="bio in listBiometric" :key="bio.subSubType" :value="bio.subSubType">
                {{ bio.translateFinger }}
              </option>
            </select>
          </div>

          <div class="recovery-box none">
            <div class="remember-me-box">
              <div></div>
              <input type="checkbox" id="remember-me">
              <span> Lembrar de mim</span>
            </div>
            <a>Esqueci minha senha</a>
          </div>

          <button class="button login-button-big" type="submit" v-bind:class="loading">
            Entrar
          </button>

        </form>

        <div v-if=response class="warning-message">
          <p>{{ response }}</p>
        </div>

      </section>

      <section class="bio-container">
        <div class="bio-box">
          <canvas id="canvas-finger" width="100%" ref="canvas"></canvas>
          <div class="bio-icon-box none">
            <img src="../../../static/img/trash-outline.svg" alt="ícone de lixo">
          </div>
        </div>

      </section>

    </section>

    <AppVersion/>

  </div>
</template>

<script>
import api from '../../api'
import Biometrics from '../../biometrics'
import Header from '../components/Header'
import AppVersion from '../components/AppVersion'

export default {
  name: 'Login',
  components: {AppVersion, Header},
  data() {
    return {
      section: 'Login',
      loading: '',
      cpf: '',
      maskCpf: '',
      biometria: '',
      response: '',
      listBiometric: []
    }
  },
  methods: {
    cpfMask() {
      if (this.maskCpf) {
        this.cpf = this.maskCpf.replace(/\D/g, '') // removendo all non numeric

        this.maskCpf = this.maskCpf // adicionando máscara
          .match(/.{1,3}/g)
          .join('.')
          .replace(/\.(?=[^.]*$)/, '-')
      }
    },
    checkCreds() {
      this.initFingerCapture()
    },
    checkBiometric: function () {
      this.resetResponse()
      this.cpfMask()
      api.request('GET', `api/v1/auth/biometrics?cpf=${this.cpf}&subType=SingleFinger`)
        .then(response => {
          this.listBiometric = response.data.biometrics
        })
        .catch(error => {
          if (error.response === undefined) {
            this.response = 'Não foi possível recuperar as Informações do usuário. O serviço parece estar offline.'
          }
          if (error.response.status === 404 || error.response.status === 204 || error.response.status === 406) {
            this.response = 'Usuário não registrado ou sem Biometria cadastrada.'
          } else {
            this.response = 'Falha ao recuperar as Informações. Erro no serviço.'
          }
        })
    },
    biometricAuthentication(cpf, wsqBase64, fingerIndex) {
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      api
        .request('post', 'api/v1/auth/loginBio', {idn: cpf, fingerIndex, fingerPrintBase64: wsqBase64, type: 'finger'})
        .then(response => {
          const data = response.data

          /* Checking if error object was returned from the server */
          if (!data.access_token) {
            this.response = 'Falha na autenticação. Por favor tente novamente.'
            return
          }

          function loadPhotoHeader(resp) {
            let listaBiometrics = resp.biometrics
            if (listaBiometrics.length > 0) {
              listaBiometrics.map((x) => {
                if (x.index === 10) {
                  window.localStorage.setItem('picture', 'data:image/jpeg;base64,' + x.content)
                }
              })
            }
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data.access_token) {
            var token = data.access_token
            var tokenParts = token.split('.')
            var body = JSON.parse(atob(tokenParts[1]))
            if (body.authorities[0] !== 'PADRAO') {
              this.$store.commit('SET_USER', data.nome)
              this.$store.commit('SET_TOKEN', token)
              if (window.localStorage) {
                window.localStorage.setItem('user', JSON.stringify(data.nome))
                window.localStorage.setItem('usercod', body.user_name)
                window.localStorage.setItem('token', token)
                window.localStorage.setItem('refresh_token', data.refresh_token)
                window.localStorage.setItem('role', body.authorities[0])
                window.localStorage.setItem('count', 0)
              }
              api
                .request('post', 'api/v1/spid/getOperator/' + cpf,
                  {}, {'Authorization': 'Bearer ' + data.access_token, 'Content-Type': 'application/json'})
                .then(resp => {
                  loadPhotoHeader(resp)
                  this.$router.push(data.redirect ? data.redirect : '/biomanager/')
                }).catch(resp => {
                  // if (resp.response.status === 404) {
                  if (resp.response.status === 302) {
                    loadPhotoHeader(resp.response.data)
                  } else {
                    console.log(resp)
                  }
                  this.$router.push(data.redirect ? data.redirect : '/biomanager/')
                  // }
                })
            } else {
              this.response = 'Usuário sem permissão de acesso.'
            }
          }
        })
        .catch(error => {
          if (error.response === undefined) {
            this.response = 'Falha na autenticação. O serviço parece estar offline.'
            this.toggleLoading()
          }
          if (error.response.data && error.response.data.message === 'Bad Credentials') {
            this.response = 'Falha na autenticação. Por favor tente novamente.'
          } else {
            this.response = 'Falha na autenticação. O serviço parece estar offline.'
            this.toggleLoading()
          }
        })
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    },
    initFingerCapture() {
      var canvas = document.getElementById('canvas-finger')
      canvas.removeAttribute('style')
      var socket = Biometrics.open()
      var cpf = this.cpf
      var fingerIndex = this.biometria
      var _this = this

      socket.addEventListener('open', function () {
        Biometrics.initFingerPrintCapture(cpf, fingerIndex)
      })

      socket.addEventListener('message', function (e) {
        var base64Server = ''
        var res = JSON.parse(e.data)
        console.log(res)

        if (res.Code === '200' || res.Code === '202' || res.Code === '203') {
          base64Server = res.FingerPrint.BitmapBase64
          var image = new Image()
          image.src = 'data:image/jpg;base64,' + base64Server
          var c = document.getElementById('canvas-finger')
          c.getContext('2d').drawImage(image, 0, 0, 105, 160)

          if (res.Code === '203') {
            var wsqBase64 = res.FingerPrint.WSQBase64
            Biometrics.close()
            _this.biometricAuthentication(cpf, wsqBase64, fingerIndex)
          }
        } else if (res.Code === '405') {
          Biometrics.close()
          _this.notifyError(
            'Captura realizada de baixa qualidade. Por gentileza realize novamente o procedimento!'
          )
        } else if (res.Code === '404') {
          Biometrics.close()
          _this.notifyError(
            'Nenhum dispositivo homologado conectado ao computador. Por gentileza verifique e realize novamente o procedimento!'
          )
        } else {
          Biometrics.close()
          _this.notifyError('Erro genérico. Erro: ' + res.Message)
        }
      })

      socket.addEventListener('close', function (e) {
      })
    },
    notifySuccess() {
      alert('Autenticação realizada com sucesso!')
      // swal({
      //   title: "Autenticação realizada com sucesso!",
      //   text: "redirecionando para página inicial ...",
      //   timer: 2000,
      //   type: "success",
      //   showConfirmButton: false
      // }).then(function() {
      //   window.location.href = "#/admin/overview";
      // });
    },
    notifyError(message) {
      alert(message)
      // swal({
      //   title: "Erro!",
      //   text: message,
      //   type: "error"
      // });
    }
  }
}
</script>

<style>
html,
body {
  height: 100%;
  background-color: var(--color-ffffff);
}

.body-container {
  margin: 3% 0 0 16%;
  padding-bottom: 4rem;
  width: 70vw;
  gap: 17rem;
  display: grid;
  grid-template-columns: 2fr 1fr;
}

.login-container {
  display: flex;
  flex-direction: column;
  min-width: 70%;
  gap: 3rem;
  margin: 20px;
}

.login-tittle {
  font: var(--font-style-normal) normal 600 var(--font-size-40)/var(--line-spacing-25) var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  text-align: left;
  color: #211858;
  opacity: 1;
}

.login-input-box {
  margin: 20px 0 0 0;
}

.login-input {
  font: var(--font-style-normal) normal var(--font-weight-medium) var(--font-size-16)/var(--line-spacing-21) var(--font-family-poppins);
  font-size: var(--font-size-16);
  letter-spacing: var(--character-spacing-0);
  min-width: 205px;
  width: 100%;
  text-align: left;
  color: #AEAEAE;
  opacity: 1;

  border: 1px solid var(--color-64696e);
  border-radius: 5px;
  padding: 6px 0 6px 5px;
}

.login-label {
  font: var(--font-style-normal) normal var(--font-weight-medium) var(--font-size-20)/var(--line-spacing-25) var(--font-family-poppins);
  font-size: var(--font-size-20);
  text-align: left;
  letter-spacing: 0;
  color: var(--grey);
}

.login-label > span {
  font: var(--font-style-normal) normal var(--font-weight-medium) var(--font-size-16)/var(--line-spacing-25) var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  text-align: left;
  color: var(--yellow);
}

.recovery-box {
  display: flex;
  justify-content: space-between;
}

.recovery-box > a {
  width: 51%;
  height: 23px;
  font: var(--font-style-normal) normal 600 var(--font-size-16)/var(--line-spacing-25) var(--font-family-poppins);
  font-size: var(--font-size-10);
  letter-spacing: var(--character-spacing-0);
  text-align: right;
  text-decoration: underline;
  color: #0000FF;
  opacity: 1;
  white-space: nowrap;
}

.remember-me-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 45%;
  height: 23px;
  font: var(--font-style-normal) normal var(--font-weight-normal) var(--font-size-16)/var(--line-spacing-25) var(--font-family-poppins);
  font-size: var(--font-size-10);
  letter-spacing: var(--character-spacing-0);
  text-align: left;
  color: var(--grey);
  opacity: 1;
}

.remember-me-box > a {
  white-space: nowrap;
  min-width: 4.5rem;
}

.remember-me-box > span {
  white-space: nowrap;
  margin-left: 3%;
}

.login-button-big {
  align-self: center;
  padding: 5px 25px;
  margin: 51px 0 40px 0;
  border-radius: 8px;
  display: block;

  font: var(--font-style-normal) normal 500 var(--font-size-16)/var(--line-spacing-25) var(--font-family-poppins);
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0;
  font-size: var(--font-size-14);
  color: #FFFFFF;
  opacity: 1;
}

.warning-message {
  font: var(--font-style-normal) normal 600 var(--font-size-20)/var(--line-spacing-25) var(--font-family-poppins);
  font-size: var(--font-size-14);
  letter-spacing: var(--character-spacing-0);
  text-align: center;
  color: var(--blue);
}

.warning-message > a {
  text-decoration: underline;
}

.bio-box {
  position: relative;
  top: 0;
  left: 0;

  display: flex;
  margin: 20px 0 0 0;
  width: 207px;
  height: 224px;
  border: 3px dashed #CCCCCC;
  border-radius: 18px;
  opacity: 1;
}

.bio-box > canvas {
  position: relative;
  top: 0;
  left: 0;

  width: 147px;
  height: 173px;
  margin: auto;
  border-radius: 10px;
  border: 1px solid var(--color-707070);
  background: transparent 0 0 no-repeat padding-box;
  opacity: 1;
}

.bio-icon-box {
  position: absolute;
  top: 170px;
  left: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 36px;
  background: var(--color-ffffff) 0 0 no-repeat padding-box;
  border: 1px solid #CCCCCC;
  border-radius: 10px;
  opacity: 1;
}

.bio-icon-box > img {
  width: 17px;
  height: 18px;
  filter: invert(41%) sepia(23%) saturate(2886%) hue-rotate(326deg) brightness(99%) contrast(88%);
}

/* MEDIA QUERY */
@media (max-width: 64em) {
  /*  1024px */
  .body-container {
    gap: 6rem;
  }

  .login-input {
    min-width: 17.5rem;
  }
}

@media (max-width: 47em) {
  /* 752px */
  .body-container {
    width: 100%;
    gap: 1rem;
    margin: 4% auto 2% auto;
    grid-template-columns: 1fr;
  }

  .login-container {
    margin: 0 auto 0 auto;
  }

  .bio-container {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?52702642